import React from 'react';
// 버튼 갯수 지정하는 comp reducer 의 setButtons => SET_BUTTONS
// 버튼의 기본값을 넣어주고 "ButtonInfoCompClass" 에서 UPDATE_BUTTONS를 통해 버튼 정보 update
class ButtonCountCompClass extends React.Component{
    constructor(props) {
        super(props);
        this.handleButtonCount = this.handleButtonCount.bind(this);
        this.state={}
    }// end constructor

    handleButtonCount = (e) => {

        const { value } = e.target;
        const { index, SelfAction, handleButtonCount } = this.props;
        handleButtonCount(e);
        let { buttons } = this.props;
        const targetLength = Number(value); // 목표 버튼 개수

        if (targetLength === 0) {
            buttons = [];
        } else if (buttons.length < targetLength) {
            // 부족한 개수만큼 추가
            const toAdd = targetLength - buttons.length;
            buttons = [...buttons, ...Array.from({ length: toAdd }, () => ({ ...{ type: '0', name: '', val1: 'https://' } }))];
        } else if (buttons.length > targetLength) {
            // 남는 버튼 제거 (뒤에서부터)
            buttons = buttons.slice(0, targetLength);
        }

        SelfAction.setButtons(buttons, index);
    };


    render() {
        const { index, isRemind, buttonCount } = this.props;
        const { handleButtonCount } = this;
        return(
            <>
                {/*버튼에 해당하는 내용 */}
                {/*모든 스펙에서 버튼이 2개까지 인것을 확인 ==> radio를 통한 만들고자 하는 사용자가 없음, 1개, 2개를 선택해서 입력 할 수 있도록 구현*/}
                <div className="d-flex align-items-center">
                    <div className="form-check pe-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name={"buttoncount"+index}
                            id={"buttoncount"+index+"_1"}
                            value={0}
                            onChange={handleButtonCount}
                            checked={buttonCount.length === 0}
                            disabled={isRemind === true}
                        />
                        <label className="form-check-label" htmlFor={"buttoncount"+index+"_1"}>
                            없음
                        </label>
                    </div>
                    <div className="form-check pe-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name={"buttoncount"+index}
                            id={"buttoncount"+index+"_2"}
                            value={1}
                            onChange={handleButtonCount}
                            checked={buttonCount.length === 1}
                            disabled={isRemind === true}
                        />
                        <label className="form-check-label" htmlFor={"buttoncount"+index+"_2"}>
                            1개
                        </label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name={"buttoncount"+index}
                            id={"buttoncount"+index+"_3"}
                            value={2}
                            onChange={handleButtonCount}
                            checked={buttonCount.length === 2}
                            disabled={isRemind === true}
                        />
                        <label className="form-check-label" htmlFor={"buttoncount"+index+"_3"}>
                            2개
                        </label>
                    </div>
                </div>
            </>
        )
    }// end render
}// end class

export default ButtonCountCompClass;
